import * as S from './styles'

import { Icon, SlimButton } from 'components'
import { theme } from 'styles/theme/hav-theme'
import { formatToPTBRNumber, numberToDecimalString } from 'commons/utils/number'

interface FooterProps {
  amountOfPairs: number
  amountOfBoxes: number
  totalValue: number
  loading: boolean
  onSubmit: () => void
  onDelete: () => void
}

/*
  @example
    <Footer
      amountOfPairs={528}
      amountOfBoxes={44}
      totalValue={10601.4}
      onSubmit={function (): void {}}
      onDelete={function (): void {}}
    />
*/
const Footer: React.FC<FooterProps> = ({
  amountOfPairs = 0,
  amountOfBoxes = 0,
  totalValue = 0,
  loading,
  onSubmit,
  onDelete
}) => {
  const handleSubmit = () => {
    onSubmit()
  }

  const handleDelete = () => {
    onDelete()
  }

  return (
    <S.Container>
      <S.InfoContainer>
        <S.Info>
          <S.InfoTitle>Volume de pares</S.InfoTitle>
          <S.InfoValue>{numberToDecimalString(amountOfPairs)}</S.InfoValue>
        </S.Info>

        <S.Info>
          <S.InfoTitle>Volume de caixas</S.InfoTitle>
          <S.InfoValue>{numberToDecimalString(amountOfBoxes)}</S.InfoValue>
        </S.Info>

        <S.Info>
          <S.InfoTitle>Valor total</S.InfoTitle>
          <S.InfoValue>{`${formatToPTBRNumber(totalValue)}`}</S.InfoValue>
        </S.Info>
      </S.InfoContainer>
      <S.ButtonsContainer>
        <SlimButton
          content="Excluir"
          variant={'ghost'}
          iconColor={theme.colors.alert.danger[30]}
          icon={<Icon icon="trash" color={theme.colors.alert.danger[30]} size="18" />}
          onClick={handleDelete}
          loading={loading}
        />
        <SlimButton
          content="Solicitar"
          variant={'primary'}
          icon={<Icon icon="send" color={theme.colors.neutral.white} size="17" />}
          onClick={handleSubmit}
          loading={loading}
        />
      </S.ButtonsContainer>
    </S.Container>
  )
}

export default Footer
